import React, {useState, useEffect} from 'react';
import {Alert} from 'react-bootstrap';

const AnnouncementAlert = () => {
  const [showAlert, setShowAlert] = useState(
    localStorage.getItem('restructureAnnouncementAlert') || 'off'
  );

  useEffect(() => {
    if (showAlert !== 'on') localStorage.setItem('restructureAnnouncementAlert', showAlert);
  }, [showAlert]);

  return (
    <Alert show={showAlert === 'on'} onClose={() => setShowAlert('off')} variant="info" dismissible>
      <b>Welcome!</b> We&apos;ve just launched our new site 🎉.{' '}
      <a href="/announcements/st-jude-cloud-restructure/" onClick={() => setShowAlert('off')}>
        Click here
      </a>{' '}
      to read about how things are changing.
    </Alert>
  );
};

export default AnnouncementAlert;
